import type { StateStorage } from 'zustand/middleware';

const guardedStorage = (label: string, source: () => Storage): StateStorage => {
  const written = new Map<string, string>();

  return {
    getItem: (key) => {
      try {
        return source().getItem(key);
      } catch (err) {
        console.warn(`[${label}] read skipped:`, err);
        return null;
      }
    },
    setItem: (key, value) => {
      if (written.get(key) === value) return;
      try {
        source().setItem(key, value);
        written.set(key, value);
      } catch (err) {
        console.warn(`[${label}] persist skipped:`, err);
      }
    },
    removeItem: (key) => {
      written.delete(key);
      try {
        source().removeItem(key);
      } catch (err) {
        console.warn(`[${label}] remove skipped:`, err);
      }
    },
  };
};

export const safeLocalStorage = guardedStorage('workflow-storage', () => localStorage);
export const safeSessionStorage = guardedStorage('batch-storage', () => sessionStorage);
